import React, { Fragment, useEffect, useState } from "react"
import PropTypes from "prop-types"
import API from "../../api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {
  Row,
  Col,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Form,
  Label,
  Input,
} from "reactstrap"
import { withRouter } from "react-router"
import { withTranslation } from "react-i18next"

import { Slide, toast, ToastContainer } from "react-toastify"
import { AvForm } from "availity-reactstrap-validation"
import FileDownload from "js-file-download"
import Select from "react-select"
import Switch from "react-switch"

const DataTableAvisEtudiant = props => {
  const [loading, setLoading] = useState(false)
  const [modal, setModal] = useState(false)
  const [id, setId] = useState("")
  const [file, setFile] = useState(null)
  const [orders, setOrders] = useState([])
  const [title, setTitle] = useState("")
  const [description, setDescription] = useState("")
  const [status, setStatus] = useState(0)
  const [add, setAdd] = useState(0)
  const [update, setUpdate] = useState(0)
  const [supprimer, setSupprimer] = useState(0)
  const [cloture, setCloture] = useState(0)
  const [cycle, setCycle] = useState([])
  const [selectCycle, setSelectCycle] = useState("")
  const [niveau, setNiveau] = useState([])
  const [selectNiveau, setSelectNiveau] = useState("")
  const [semestre, setSemestre] = useState([
    { value: 1, label: "Semestre 1" },
    { value: 2, label: "Semestre 2" },
  ])
  const [selectSemestre, setSelectSemestre] = useState("")
  const [specialite, setSpecialite] = useState([])
  const [selectSpecialite, setSelectSpecialite] = useState("")
  const [groupe, setGroupe] = useState([])
  const [selectGroupe, setSelectGroupe] = useState("")
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: orders.length,
    page: 1,
    nextPageText: "Suivant",
    prePageText: "Précédent",
    alwaysShowAllBtns: true,
    sizePerPage: 30,
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "300",
        value: 300,
      },
      {
        text: "All",
        value: orders.length,
      },
    ],
  }
  const addFile = e => {
    var file = e.target.files[0]
    setFile(file)
  }
  const NoDataIndication = () => (
    <h6 style={{ textAlign: "center" }}>No record to display</h6>
  )
  const Columns = () => [
    {
      dataField: "semestre",
      text: props.t("Semestre"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "cycle",
      text: props.t("Cycle"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "niveau",
      text: props.t("Niveau"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "specialite",
      text: props.t("Spécialité"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "group_tds",
      text: props.t("Groupe"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "titre",
      text: props.t("Titre"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "contenu",
      text: props.t("Description"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      formatter: cell => {
        if (!cell) return ""
        const words = cell.split(" ")
        if (words.length > 7) {
          const firstLine = words.slice(0, 7).join(" ")
          const rest = words.slice(7).join(" ")
          return (
            <>
              {firstLine} <br /> {rest}
            </>
          )
        }
        return cell
      },
    },
    {
      dataField: "Modifier",
      isDummyField: true,
      text: props.t("Modifier"),
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        cloture != 1 ? (
          update == 1 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "cornflowerblue", cursor: "pointer" }}
                onClick={() => getById(row.id)}
                className="fas fa-edit"
              ></i>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#a7a3a3", cursor: "pointer" }}
                className="fas fa-edit"
                title="Vous n'avez pas le droit de modifier l'avis enseignant"
              ></i>
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              className="fas fa-edit"
              title="Année clôturée"
            ></i>
          </div>
        ),
    },
    {
      dataField: "id",
      isDummyField: true,
      text: "Téléchargement",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <a
          onClick={() => download2(row.id, row.titre)}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <i
            style={{ color: "#955cd5", cursor: "pointer" }}
            className="fas fa-file-download"
          ></i>
        </a>
      ),
    },
    {
      dataField: "active",
      isDummyField: true,
      text: "Etat",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (colIndex, row) =>
        cloture != 1 ? (
          update == 1 ? (
            <Switch
              uncheckedIcon={<Offsymbol />}
              checkedIcon={<OnSymbol />}
              className="me-1 mb-sm-8 mb-2"
              onColor="#34c38f"
              onChange={() => activeAvis(row)}
              checked={row.active}
            />
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Switch
                title="Vous n'avez pas le droit de modifier l'avis enseignant"
                uncheckedIcon={<Offsymbol />}
                checkedIcon={<OnSymbol />}
                className="me-1 mb-sm-8 mb-2"
                onColor="#34c38f"
                onChange={() => activeAvis(row)}
                checked={row.active}
                disabled={true}
              />
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Switch
              title="Année clôturée"
              uncheckedIcon={<Offsymbol />}
              checkedIcon={<OnSymbol />}
              className="me-1 mb-sm-8 mb-2"
              onColor="#34c38f"
              onChange={() => activeAvis(row)}
              checked={row.active}
              disabled={true}
            />
          </div>
        ),
    },
    {
      dataField: "Suppression",
      isDummyField: true,
      text: props.t("Suppression"),
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        cloture != 1 ? (
          supprimer == 1 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#ED6464", cursor: "pointer" }}
                onClick={() => toggle(row.id)}
                className="fas fa-trash-alt"
              ></i>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#a7a3a3", cursor: "pointer" }}
                className="fas fa-trash-alt"
                title="Vous n'avez pas le droit de supprimer l'avis enseignant"
              ></i>
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              className="fas fa-trash-alt"
              title="Année clôturée"
            ></i>
          </div>
        ),
    },
  ]
  const download2 = async (id, titre) => {
    try {
      // On attend la réponse avec await
      const res = await API.post(
        "avis_etudiants/download",
        {
          id: id,
        },
        { responseType: "blob" } // Important pour les fichiers binaires
      )
      // On télécharge le fichier avec le nom souhaité
      FileDownload(res.data, `${titre}.pdf`)
    } catch (error) {
      console.error("Erreur lors du téléchargement :", error)
      toast.error("❌ Échec du téléchargement", { containerId: "A" })
    }
  }
  const { SearchBar } = Search
  useEffect(async () => {
    const loadData = async () => {
      try {
        const cloture_annee = JSON.parse(localStorage.getItem("cloture"))
        setCloture(cloture_annee)
        const userAuth = JSON.parse(localStorage.getItem("UserMenu")) || []
        const typeArticleSubMenu = userAuth.find(
          user =>
            Array.isArray(user.sous_menu) &&
            user.sous_menu.some(
              subMenu => subMenu.sous_menu === "Avis pour les étudiants"
            )
        )
        if (typeArticleSubMenu) {
          const menu = typeArticleSubMenu.sous_menu.find(
            subMenu => subMenu.sous_menu === "Avis pour les étudiants"
          )
          if (menu) {
            setAdd(menu.add)
            setUpdate(menu.edit)
            setSupprimer(menu.delete)
          }
        } else {
          console.warn(
            "Le sous-menu 'Avis pour les étudiants' est introuvable."
          )
        }
      } catch (error) {
        console.error(error)
      }
    }
    loadData()
    const res = await API.post("avis_etudiants/liste_avis", { annee_id }).then(
      res => {
        setOrders(res.data.Avis)
      }
    )
    // cycle
    const resCycle = await API.get("cycle/select").then(resCycle => {
      setCycle(resCycle.data.Cycle)
    })
    //niveau
    const resNiveau = await API.get("niveau/select").then(resNiveau => {
      setNiveau(resNiveau.data.Niveau)
    })
    setLoading(true)
  }, [])
  const toggle = id => {
    setModal(!modal)
    setId(id)
  }
  const getById = id => {
    const resE = API.post("avis_etudiants/get_by_id", { id }).then(resE => {
      API.post("specialite/get_by_niveau", {
        niveau_id: resE.data.Avis.niveau_id.value,
        cycle_id: resE.data.Avis.cycle_id.value,
        annee_id,
      }).then(res => {
        setSpecialite(res.data.specialite)
      })
      API.post("group/getbyspSem", {
        specialite_id: resE.data.Avis.specialite_id.value,
        cycle_id: resE.data.Avis.cycle_id.value,
        niveau_id: resE.data.Avis.niveau_id.value,
        semestre_id: resE.data.Avis.semestre_id.value,
        annee_id: annee_id,
      }).then(resSM => {
        setGroupe(resSM.data.groups)
      })
      setId(resE.data.Avis.id)
      setSelectGroupe(resE.data.Avis.group_tds)
      setTitle(resE.data.Avis.titre)
      setDescription(resE.data.Avis.contenu)
      setStatus(resE.data.Avis.active)
      setSelectCycle(resE.data.Avis.cycle_id)
      setSelectNiveau(resE.data.Avis.niveau_id)
      setSelectSemestre(resE.data.Avis.semestre_id)
      setSelectSpecialite(resE.data.Avis.specialite_id)
    })
  }
  const toggleDelete = async () => {
    try {
      await API.post("avis_etudiants/delete_avis", {
        id,
        annee_id,
        user_id,
      })
      const resS = await API.post("avis_etudiants/liste_avis", {
        annee_id,
      })
      if (resS.data && resS.data.Avis) {
        setModal(false)
        setOrders(resS.data.Avis)
        setId("")
      }
    } catch (error) {
      console.error(error)
    }
  }
  const save = async () => {
    var pathFile = ""
    if (file != null) {
      pathFile = file.name
    }
    if (pathFile !== "") {
      const formData = new FormData()
      formData.append("titre", title)
      formData.append("contenu", description)
      formData.append("annee_id", annee_id)
      formData.append("active", status)
      formData.append("cycle_id", selectCycle.value)
      formData.append("niveau_id", selectNiveau.value)
      formData.append("semestre_id", selectSemestre.value)
      formData.append("specialite_id", selectSpecialite.value)
      formData.append("group_td_ids",JSON.stringify(selectGroupe.map(item => item.value)))
      formData.append("fichier", file)
      try {
        // ATTENTION ici: await pour récupérer la réponse
        const resA = await API.post("avis_etudiants/add_avis", formData)

        // Vérification que resA.data existe
        if (resA?.data?.errNum === 200 || resA?.data?.errNum === "200") {
          setSelectGroupe("")
          setSelectCycle("")
          setSelectNiveau("")
          setSelectSemestre("")
          setSelectSpecialite("")
          setFile("")
          setTitle("")
          setDescription("")
          setStatus(0)
          toast.success("🔓✔️  Avis Etudiant ajouté Avec succès", {
            containerId: "A",
          })

          const res = await API.post("avis_etudiants/liste_avis", { annee_id })
          setOrders(res.data.Avis)
        }
      } catch (error) {
        console.error("Erreur lors de l'enregistrement :", error)
        toast.error("❌ Une erreur est survenue", { containerId: "A" })
      }
    }
  }
  const edit = async () => {
    var pathFile = ""
    if (file != null) {
      pathFile = file.name
    }
    const formData = new FormData()
    if (pathFile !== "") {
      formData.append("fichier", file)
    }
    formData.append("id", id)
    formData.append("titre", title)
    formData.append("contenu", description)
    formData.append("annee_id", annee_id)
    formData.append("active", status)
    formData.append("cycle_id", selectCycle.value)
    formData.append("niveau_id", selectNiveau.value)
    formData.append("semestre_id", selectSemestre.value)
    formData.append("specialite_id", selectSpecialite.value)
    formData.append("group_td_ids", JSON.stringify(selectGroupe.map(item => item.value)))
    try {
      // ATTENTION ici: await pour récupérer la réponse
      const resA = await API.post("avis_etudiants/edit_avis", formData)
      // Vérification que resA.data existe
      if (resA?.data?.errNum === 200 || resA?.data?.errNum === "200") {
        setTitle("")
        setDescription("")
        setStatus(0)
        setId("")
        setSelectGroupe("")
        setSelectNiveau("")
        setSelectSemestre("")
        setSelectSpecialite("")
        setSelectCycle("")
        toast.success("🔓✔️  Avis Enseignant ajouté Avec succès", {
          containerId: "A",
        })
        const res = await API.post("avis_etudiants/liste_avis", { annee_id })
        setOrders(res.data.Avis)
      }
    } catch (error) {
      console.error("Erreur lors de l'enregistrement :", error)
      toast.error("❌ Une erreur est survenue", { containerId: "A" })
    }
  }
  const annuler = async () => {
    setTitle("")
    setDescription("")
    setStatus(0)
    setId("")
    setSelectGroupe("")
    setSelectNiveau("")
    setSelectSemestre("")
    setSelectSpecialite("")
    setSelectCycle("")
  }

  const Offsymbol = () => {
    return (
      <div
        title="Activé"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        A
      </div>
    )
  }

  const OnSymbol = props => {
    return (
      <div
        title="Désactivé"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        D
      </div>
    )
  }

  const activeAvis = async row => {
    var active = row.active
    var avis_id = row.id
    if (active == 0) {
      var active = 1
      const res = await API.post("avis_etudiants/update_etat", {
        id: avis_id,
        active: active,
      }).then(res => {
        toast.success(" 🔓✔️ Avis étudiant Activé Avec succès", {
          containerId: "A",
        })
        API.post("avis_etudiants/liste_avis", { annee_id }).then(resE => {
          setOrders(resE.data.Avis)
          setLoading(true)
        })
      })
    } else if (active == 1) {
      var active = 0
      const res = await API.post("avis_etudiants/update_etat", {
        id: avis_id,
        active: active,
      }).then(res => {
        toast.success(" 🔒❌ Avis étudiant Désactivé Avec succès ", {
          containerId: "A",
        })
        API.post("avis_etudiants/liste_avis", { annee_id }).then(resE => {
          setOrders(resE.data.Avis)
          setLoading(true)
        })
      })
    }
  }

  const getSpec = async event => {
    setSelectSpecialite("")
    setSelectGroupe("")
    setSelectNiveau(event)
    const res = await API.post("specialite/get_by_niveau", {
      niveau_id: event.value,
      cycle_id: selectCycle.value,
      annee_id,
    }).then(res => {
      setSpecialite(res.data.specialite)
    })
  }

  const getGroupe = async event => {
    var specialite_id = event.value
    setSelectSpecialite(event)
    setSelectGroupe("")
    const resSM = await API.post("group/getbyspSem", {
      specialite_id: specialite_id,
      cycle_id: selectCycle.value,
      niveau_id: selectNiveau.value,
      annee_id: annee_id,
      semestre_id: selectSemestre.value,
    }).then(resSM => {
      setGroupe(resSM.data.groups)
    })

  }
  return (
    <React.Fragment>
      <div>
        {loading ? (
          <Fragment>
            <AvForm>
              <Form>
                <Row>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">Semestre :</Label>
                      <Select
                        options={semestre}
                        value={selectSemestre}
                        isSearchable={true}
                        onChange={e => setSelectSemestre(e)}
                        placeholder={props.t("Select")}
                      />
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">Cycle :</Label>
                      <Select
                        options={cycle}
                        value={selectCycle}
                        isSearchable={true}
                        onChange={e => setSelectCycle(e)}
                        placeholder={props.t("Select")}
                      />
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">Niveau :</Label>
                      <Select
                        options={niveau}
                        value={selectNiveau}
                        isSearchable={true}
                        onChange={e => getSpec(e)}
                        placeholder={props.t("Select")}
                      />
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Spécialité :
                      </Label>
                      <Select
                        options={specialite}
                        value={selectSpecialite}
                        isSearchable={true}
                        onChange={e => getGroupe(e)}
                        placeholder={props.t("Select")}
                      />
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Groupe
                      </Label>
                      <Select
                        options={groupe}
                        value={selectGroupe}
                        isSearchable={true}
                        isMulti={true}
                        onChange={e => setSelectGroupe(e)}
                        placeholder={props.t("Select")}
                      />
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">Fichier :</Label>
                      <Input
                        onChange={e => addFile(e)}
                        className="form-control"
                        type="file"
                        id="formFile"
                        accept=".pdf"
                      />
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">Titre :</Label>
                      <Input
                        lg="3"
                        className="form-control"
                        placeholder="Titre"
                        type="text"
                        value={title}
                        onChange={e => setTitle(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Description :
                      </Label>
                      <Input
                        value={description}
                        lg="3"
                        className="form-control"
                        placeholder="Description ..."
                        type="textarea"
                        onChange={e => setDescription(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">Etat :</Label>
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        checked={status === 1}
                        className="me-1 mb-sm-8 mb-2"
                        onColor="#34c38f"
                        onChange={checked => setStatus(checked ? 1 : 0)}
                      />
                    </div>
                  </Col>
                </Row>
              </Form>
              <div style={{ display: "flex", justifyContent: "center" }}>
                {add === 1 && id === "" && (
                  <Col lg="6">
                    <div className="text-center mt-4">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={save}
                      >
                        {props.t("Confirmer")}
                      </button>
                    </div>
                  </Col>
                )}
                {update === 1 && id !== "" && (
                  <Col lg="6">
                    <div className="text-center mt-4">
                      <button
                        type="button"
                        className="btn btn-warning"
                        onClick={edit}
                      >
                        {props.t("Modifier")}
                      </button>
                      &nbsp;&nbsp;
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={annuler}
                      >
                        {props.t("Annuler")}
                      </button>
                    </div>
                  </Col>
                )}
              </div>
            </AvForm>
            <Row className="mt-4">
              <Col xs="12">
                <ToolkitProvider
                  keyField="id"
                  data={orders}
                  columns={Columns()}
                  search
                  bootstrap4
                >
                  {toolkitProps => (
                    <div>
                      <div>
                        <div className="mb-3 row" style={{ display: "flex" }}>
                          <div className="col-md-6 mb-3 row">
                            <div className="col-md-8 search-box-etd">
                              <div
                                className="search-box me-2 mb-2 d-inline-block"
                                style={{ width: "100%" }}
                              >
                                <div className="position-relative">
                                  <SearchBar {...toolkitProps.searchProps} />
                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <BootstrapTable
                        wrapperClasses="table-responsive"
                        noDataIndication={() => <NoDataIndication />}
                        striped={false}
                        bordered={false}
                        classes={"table align-middle table-nowrap"}
                        headerWrapperClasses={"table-light"}
                        hover
                        pagination={paginationFactory(pageOptions)}
                        {...toolkitProps.baseProps}
                      />
                    </div>
                  )}
                </ToolkitProvider>
              </Col>
            </Row>
          </Fragment>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <Spinner type="grow" className="ms-6" color="primary" />
            </div>
            <h4
              style={{ textAlign: "center", marginTop: "2%" }}
              className="ms-6"
            >
              {" "}
              {props.t("Chargement")} ...{" "}
            </h4>
          </div>
        )}
      </div>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
      <Modal isOpen={modal} toggle={toggle} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggle}
          tag="h4"
        >
          {props.t("Suppression")} {props.t("d'avis étudiant")}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>{props.t("Voulez-vous supprimer cette avis ?")}</p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleDelete}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  {props.t("Oui")}
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggle}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {props.t("Non")}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(DataTableAvisEtudiant))
DataTableAvisEtudiant.propTypes = {
  orders: PropTypes.array,
  history: PropTypes.object,
  t: PropTypes.any,
}
